import React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';
import { SettingsContainer } from '@atlassian/jira-software-board-settings-rapidboard-config-common';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page';
import type RapidBoardCardLayoutSettingsType from './main';

const LazyCardLayoutSettings = lazyForPaint<typeof RapidBoardCardLayoutSettingsType>(
	() =>
		import(
			/* webpackChunkName: "async-rapid-board-settings-card-layout", jiraSpaEntry: "async-rapid-board-settings-card-layout" */ './main'
		),
);

type Props = {
	pageId: string;
};

const LazyCardLayoutSettingsSpa = ({ pageId }: Props) => (
	<SettingsContainer packageId="jira-board-settings.card-layout-route">
		<LazyPage Page={LazyCardLayoutSettings} pageId={pageId} shouldShowSpinner={false} />
	</SettingsContainer>
);

export default LazyCardLayoutSettingsSpa;
